import { render } from "./AppMain.vue?vue&type=template&id=29e571ae&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=29e571ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e571ae"]])

export default __exports__